<template>
  <div>
    <div
      v-if="!datapolicyAccepted"
      class="cookie-alert px-4 py-4 bg-primary text-white"
    >
      <div class="d-flex flex-row justify-content-center">
        <p class="mb-0 align-self-center">
          Diese Webseite nutzt Cookies um das Nutzererlebnis zu verbessern. Durch die Nutzung dieser Webseite erklären Sie sich hiermit einverstanden. Weitere Details finden Sie in unserer <a
            href="https://www.berckemeyer-firmen.de/datenschutz.html"
            target="_blank"
          >Datenschutzerklärung</a>.
        </p>

        <div class="ml-auto">
          <button
            class="btn btn-danger"
            @click="setCookiePolicy"
          >
            Gelesen
          </button>
        </div>
      </div>
    </div>
    <Header />
    <div
      v-if="submitSuccess"
      class="container main mb-5 pb-5"
    >
      <div class="success">
        <h1>Vielen Dank</h1>
        <p class="subline">
          Wir haben Ihre Fragen erhalten und senden Ihnen schnellstmöglich ein passendes Angebot.
        </p>
        <div
          class="btn btn-lg btn-primary"
          @click="submitSuccess = !submitSuccess"
        >
          Neues Formular ausfüllen
        </div>
      </div>
    </div>
    <div
      v-else
      class="container main mb-5"
    >
      <ValidationObserver
        ref="fragebogenForm"
        slim
      >
        <form
          class="form"
          novalidate
          @submit.prevent="submit"
        >
          <h1>Tarifrechner</h1>
          <p class="subline">
            Wenn Sie uns die unten stehenden Fragen beantwortet haben, senden wir Ihnen schnellstmöglich ein passendes Angebot.
          </p>
          <h5 class="mt-5">
            Kontaktdaten des Versicherungsnehmers
          </h5>
          <div class="row">
            <basic-input
              v-model="fragebogen.tankstelleName"
              class="col-12 col-md-6"
              required
              label="Tankstelle (Name)"
            />
            <basic-input
              v-model="fragebogen.pblnummer"
              class="col-12 col-md-6"
              label="PBL-Nr."
            />
            <basic-input
              v-model="fragebogen.ansprechpartner"
              class="col-12 col-md-6"
              label="Ansprechpartner (Name, Vorname)"
            />
            <basic-input
              v-model="fragebogen.mobilnummer"
              class="col-12 col-md-6"
              label="Mobilnummer"
            />
            <basic-input
              v-model="fragebogen.email"
              class="col-12 col-md-6"
              label="E-Mail"
              required
            />
            <basic-input
              v-model="fragebogen.telefone"
              class="col-12 col-md-6"
              label="Telefonnummer"
            />
            <basic-input
              v-model="fragebogen.street"
              class="col-12 col-md-6"
              label="Straße / Hausnummer"
              required
            />
            <basic-input
              v-model="fragebogen.ort"
              class="col-12 col-md-6"
              label="PLZ / Ort"
              required
            />
          </div>
          <h5 class="mt-5">
            Für die Versicherung benötigen wir bitte folgende Angaben von Ihnen
          </h5>
          <div class="row">
            <basic-input
              v-model="fragebogen.risikoort"
              class="col-12 col-md-6"
              required
              label="Risikoort"
            />
            <basic-input
              v-model="fragebogen.abweichendeAdresse"
              class="col-12 col-md-6"
              label="Bei abweichender Rechnungsadresse"
            />
            <basic-radio
              v-model="fragebogen.isPaechter"
              class="col-12 my-15"
              required
              label="Sie sind …"
              name="Auswahl des Besitzverhältnis"
              :options="['Pächter','Eigentümer']"
            />
            <div class="col-12 my-15">
              <label>Tätigkeiten</label>
              <div class="row">
                <basic-checkbox
                  v-model="fragebogen.taetigkeitTankstelle"
                  class="col-6 col-md-3 mb-3"
                  label="Tankstelle"
                  :required="activitesRequired"
                />
                <basic-checkbox
                  v-model="fragebogen.taetigkeitWaschtrasse"
                  class="col-6 col-md-3 mb-3"
                  label="Waschstraße"
                  :required="activitesRequired"
                />
                <basic-checkbox
                  v-model="fragebogen.taetigkeitPortalwaschanlage"
                  class="col-6 col-md-3 mb-3"
                  label="Portalwaschanlage"
                  :required="activitesRequired"
                />
                <basic-checkbox
                  v-model="fragebogen.taetigkeitWerkstatt"
                  class="col-6 col-md-3 mb-3"
                  label="Werkstatt mit Hebebühne"
                  :required="activitesRequired"
                />
                <basic-checkbox
                  v-model="fragebogen.taetigkeitServicehalle"
                  class="col-6 col-md-3 mb-3"
                  label="Servicehalle"
                  :required="activitesRequired"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="row align-items-end">
                <basic-select
                  v-model="fragebogen.hasDrittanbieter"
                  class="col-12 col-md-6"
                  label="Gibt es in der Tankstelle Drittanbieter (z.B. Systemgastronomie?)"
                  :options="[{'value':true, 'label': 'Ja'}, {'value':false, 'label': 'Nein'}]"
                />
                <basic-input
                  v-if="fragebogen.hasDrittanbieter"
                  v-model="fragebogen.drittanbieterName"
                  class="col-12 col-md-6"
                  label="Wenn ja, welche"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-lg-4">
                  <basic-input
                    v-model="fragebogen.kassenArbeitsplaetze"
                    class=""
                    label="Anzahl der Kassen-Arbeitsplätze"
                    required
                    hint=" "
                  />
                  <basic-input
                    v-model="fragebogen.shopflaeche"
                    class=""
                    label="Größe der Shopfläche in m²"
                    hint="(gemäß Nutzungs-/Pachtvertrag)"
                    required
                  />
                  <div class="row align-items-end">
                    <basic-input
                      v-model="fragebogen.oeffnungszeitVon"
                      class="col-6 mt-md-0"
                      label="Öffnungszeiten"
                      name="Öffnungszeiten von"
                      required
                    />
                    <basic-input
                      v-model="fragebogen.oeffnungszeitBis"
                      name="Öffnungszeiten bis"
                      label=" "
                      required
                      no-label
                      class="col-6"
                    />
                  </div>
                </div>
                <div class="col-12 col-lg-4">
                  <basic-input
                    v-model="fragebogen.anzahlZapfsaeulen"
                    class=""
                    required
                    label="Anzahl Zapfsäulen / Preismasten"
                    hint="(sofern nicht Eigentum von Echo Tankstellen GmbH)"
                  />
                  <basic-input
                    v-model="fragebogen.none"
                    class="invisible"
                    label="Externes Lager / Versicherungssumme"
                    hint=" "
                  />
                  <basic-input
                    v-model="fragebogen.externesLager"
                    class=""
                    label="Externes Lager / Versicherungssumme"
                    hint=" (nicht vom Shop zugänglich) Kein Versicherungsschutz für Bargeld, Tabakwaren und Spirituosen"
                  />
                </div>

                <div class="col-12 col-lg-4">
                  <basic-input
                    v-model="fragebogen.waren"
                    class=""
                    label="Waren / Vorräte"
                    hint="Versicherungssumme zum Neuwert"
                  />
                  <basic-input
                    v-model="fragebogen.betriebseinrichtungen"
                    class=""
                    label="Betriebseinrichtungen"
                    hint="(ohne Eigentum der Echo) Versicherungssumme zum Neuwert"
                  />
                  <basic-input
                    v-model="fragebogen.waschanlage"
                    class=""
                    label="Waschanlage"
                    hint="Versicherungssumme zum Neuwert"
                  />
                </div>
              </div>
            </div>
          </div>
          <h5 class="mt-5">
            Gewünschter Versicherungsumfang
          </h5>
          <div class="row mt-15">
            <basic-checkbox
              v-model="fragebogen.inhaltsversicherung"
              class="col-12 col-md-6 my-2"
              label="Inhaltsversicherung"
              hint="Bargeld, Waren/Vorräte, Einrichtung (ohne Eigentum der Echo) und Betriebsunterbrechung"
            />
            <basic-checkbox
              v-model="fragebogen.gebaeudeversicherung"
              class="col-12 col-md-6 my-2"
              label="Gebäudeversicherung"
              hint="Nur für Eigentümer der Tankstelle"
            />
            <basic-checkbox
              v-model="fragebogen.betriebshaftpflicht"
              class="col-12 col-md-6 my-2"
              label="Betriebshaftpflicht"
              hint="Umweltschaden- und Umwelthaftpflichtversicherung eingeschlossen"
            />
            <basic-checkbox
              v-model="fragebogen.glas"
              class="col-12 col-md-6 my-2"
              label="Glas"
            />
            <basic-checkbox
              v-model="fragebogen.elektronik"
              class="col-12 col-md-6 my-2"
              label="Elektronik"
              hint="z. B. Kassen, EMA, Video, Kaffeeautomaten, sonstige elektronische Geräte"
            />
            <basic-checkbox
              v-model="fragebogen.cyberversicherung"
              class="col-12 col-md-6 my-2"
              label="Cyberversicherung"
            />
          </div>
          <h5 class="mt-5">
            Risikofragen
          </h5>

          <ol class="ml-0 risikofragen">
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Steht das Gebäude / eines der Gebäude leer oder teilweise leer?<br>
                    (Leerstand ab ca. 40 % der Fläche)
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.riskofrage1"
                      name="Risikofrage 1"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Hat das Gebäude / eines der Gebäude eine oder mehrere offene Seiten?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.riskofrage2"
                      name="Risikofrage 2"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row align-items-start mb-2">
                <div class="col-6">
                  <p>
                    Baujahr des Gebäudes
                  </p>
                </div>
                <div class="col-auto">
                  <basic-input
                    v-model="fragebogen.riskofrage3"
                    class="m-0 p-0"
                    no-label
                  />
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Befinden sich Sachen in Traglufthallen oder Zelten?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.riskofrage4"
                      name="Risikofrage 4"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Sind die Außenwände des Gebäudes / der Gebäude überwiegend
                    aus Holz oder hat das Gebäude / eines der Gebäude eine weiche
                    Bedachung (Holz, Ried, Schilf oder Stroh)?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.riskofrage5"
                      name="Risikofrage 5"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Ab einer Shopfläche von 50 m² ist eine VdS-anerkannte
                    Einbruchmeldeanlage (EMA) Voraussetzung für den Einbruchdiebstahl
                    und Beraubungsschutz

                    <ul class="hint">
                      <li>
                        Die Anforderung bei einer neu zu errichtenden EMA ergibt sich aus dem Merkblatt zur
                        Installation einer EMA für Tankstationen der Echo.
                      </li>
                      <li>
                        Bei vorhandenen Einbruchmeldeanlagen sind folgende Unterlagen zur Prüfung an die
                        Gothaer Allgemeine Versicherung AG (über: hoeper@berckemeyer.eu)
                        einzureichen:
                        <br>
                        <br>
                        – VdS-Anlagenbeschreibung <br>
                        – Lageplan <br>
                        – Alarmdienst- und Interventionsattest
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </li>
          </ol>
          <a
            class="dokumentLink mb-5 d-block"
            :href="pdfPath"
            target="_blank"
            download="Voraussetzungen_Einbruchdiebstahlversicherung.pdf"
          >Bitte beachten Sie die Voraussetzungen für den Versicherungsschutz in der Einbruchdiebstahlversicherung</a>
          <p v-if="fragebogen.cyberversicherung">
            Folgende Fragen sind nur zu beantworten, wenn eine <b>Cyberversicherung</b> beantragt wird
          </p>
          <ol
            v-if="fragebogen.cyberversicherung"
            class="risikofragen"
            start="6"
          >
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Werden in der IT-Infrastruktur der zu versichernden Unternehmen
                    Industrial Control Systeme (ICS) wie Supervisory Control und
                    Data Acquisition (SCADA) oder Distributed Control Systeme (DCS)
                    eingesetzt?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.cyberfrage1"
                      name="Cyberfrage 1"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
              <p>
                Wenn ja, dann
              </p>

              <div class="row">
                <div class="col-6">
                  <p class="pl-3">
                    Befinden sich die IC-Systeme in einem separierten Netzwerk mit
                    eingeschränkten Zugriffsmöglichkeiten?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.cyberfrage2"
                      name="Cyberfrage 2"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <p class="pl-3">
                    Erfolgt der Fernzugriff auf IC-Systeme ausschließlich auf verschlüsseltem
                    Weg und / oder mittels einer 2 Faktor-Authentifizierung?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.cyberfrage3"
                      name="Cyberfrage 3"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Bearbeiten, speichern oder übermitteln die zu versichernden
                    Unternehmen im Jahr weniger als 20.000 Kreditkartendaten und
                    halten die Standards gemäß PCI DSS (Payment Card Industry Data
                    Security Standard) ein?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.cyberfrage4"
                      name="Cyberfrage 4"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="row">
                <div class="col-6">
                  <p>
                    Werden die Mitarbeiter der zu versichernden Unternehmen
                    regelmäßig zu Informationssicherheit und Cyber-Sicherheit sensibilisiert
                    oder geschult?
                  </p>
                </div>
                <div class="col-6 col-md-4">
                  <div class="row">
                    <basic-radio
                      v-model="fragebogen.cyberfrage5"
                      name="Cyberfrage 5"
                      class="col-auto"
                      required
                      no-label
                      :options="[{
                        text: 'Nein',
                        value: false
                      }, {
                        text: 'Ja',
                        value: true
                      }]"
                    />
                  </div>
                </div>
              </div>
            </li>
          </ol>
          <div class="row">
            <basic-input
              v-model="fragebogen.risikofrageExtra"
              class="col-12 col-md-6"
              name="Fragen nicht zutreffend"
            >
              <template #label>
                Ist eine der aufgeführten Fragen für Sie nicht zutreffend,<br>
                wenn ja, welche
              </template>
            </basic-input>
          </div>
          <h5 class="mt-5 mb-4">
            Umsatz
          </h5>
          <p>Umsatz im abgelaufenen Kalenderjahr</p>
          <div class="row">
            <basic-currency-input
              v-model="fragebogen.umsatzKraftstoff"
              class="col-12 col-md-6"
              label="1. Kraftstoff, Umsatz in EUR"
            />
            <basic-currency-input
              v-model="fragebogen.umsatzWaschanlage"
              class="col-12 col-md-6"
              label="2. Waschanlage, Umsatz in EUR"
            />
            <basic-currency-input
              v-model="fragebogen.umsatzShop"
              class="col-12 col-md-6"
              label="3. Shop, Umsatz in EUR"
            />
          </div>
          <h5 class="mt-5">
            Bestehende (Vor-) Versicherungen
          </h5>
          <div class="row align-items-center">
            <basic-checkbox
              v-model="fragebogen.vorgaengerInhaltsversicherung"
              class="col-12 col-md-6"
              label="Inhaltsversicherung"
            />
            <basic-input
              v-model="fragebogen.versicherungsnummer1"
              class="col-12 col-md-6"
              label="Versicherungsgesellschaft und Vertragsnummer"
            />
          </div>
          <div class="row align-items-center">
            <basic-checkbox
              v-model="fragebogen.vorgaengerBetriebshaftpflicht"
              class="col-12 col-md-6"
              label="Betriebshaftpflicht"
            />
            <basic-input
              v-model="fragebogen.versicherungsnummer2"
              class="col-12 col-md-6"
              label="Versicherungsgesellschaft und Vertragsnummer"
            />
          </div>
          <div class="row align-items-center">
            <basic-checkbox
              v-model="fragebogen.vorgaengerElektronik"
              class="col-12 col-md-6"
              label="Elektronikversicherung"
            />
            <basic-input
              v-model="fragebogen.versicherungsnummer3"
              class="col-12 col-md-6"
              label="Versicherungsgesellschaft und Vertragsnummer"
            />
          </div>
          <div class="row align-items-center">
            <basic-checkbox
              v-model="fragebogen.vorgaengerGlas"
              class="col-12 col-md-6"
              label="Glasversicherung"
            />
            <basic-input
              v-model="fragebogen.versicherungsnummer4"
              class="col-12 col-md-6"
              label="Versicherungsgesellschaft und Vertragsnummer"
            />
          </div>
          <div class="row align-items-center">
            <basic-checkbox
              v-model="fragebogen.vorgaengerCyberversicherung"
              class="col-12 col-md-6"
              label="Cyberversicherung"
            />
            <basic-input
              v-model="fragebogen.versicherungsnummer5"
              class="col-12 col-md-6"
              label="Versicherungsgesellschaft und Vertragsnummer"
            />
          </div>
          <p class="font-esso">
            Hinweise zum Datenschutz
          </p>
          <basic-checkbox
            v-model="fragebogen.grundsaetzeDatenverarbeitung"
            label="Grundsätze der Datenverarbeitung"
            required
          >
            <template #hint>
              <p class="text-justify">
                Der Kunde willigt ein, dass seine personenbezogenen Daten aus den Antragsunterlagen und der Vertragsdurchführung (z. B. Beiträge, Versicherungsfälle, Kündigungen, Risiko- und Vertragsänderungen) erhoben,
                verarbeitet und verwendet, sowie an Versicherer bzw. Vermittler oder an andere mit der Vermittlung und Betreuung befasste Personen und Unternehmen übermittelt
                werden, soweit dies zur ordnungsgemäßen Durchführung der Versicherungsangelegenheiten erforderlich ist. Der Makler Berckemeyer kann aufgrund seiner Tätigkeit ein Gesamtbild über die
                in Anspruch genommene Versicherungsleistung erhalten. Gesundheitsdaten werden nur mit einer expliziten Einwilligung des Betroffenen verarbeitet. Weitergehende Informationen finden Sie
                auf unserer Website www.berckemeyer.eu. Diese Hinweise stellen wir Ihnen auf Wunsch auch in Papierform zur Verfügung.
              </p>
            </template>
          </basic-checkbox>
          <basic-checkbox
            v-model="fragebogen.einwilligungDatenverarbeitung"
            label="Einwilligung in die Datenverarbeitung"
            required
          >
            <template #hint>
              <p class="text-justify">
                Kommunikation <br>
                Der Kunde willigt ausdrücklich ein, dass ihn der Makler Berckemeyer mittels sämtlicher Medien kontaktiert und ihn, auch über die bestehenden Geschäftsbeziehungen hinausreichend,
                informieren darf. Hierdurch sollen vor allem die reibungslose Übergabe der Betreuung und die Abwicklung etwaiger nachvertraglicher Fragen im Interesse des Auftraggebers gesichert werden.
                Diese Einwilligung kann vom Kunden jederzeit beschränkt oder widerrufen werden.
              </p>
              <p>
                Widerrufsrecht
                <br>
                Der Kunde kann diese Einwilligung jederzeit auch teilweise mit Wirkung für die Zukunft widerrufen.
                <br>
                Der Kunde erklärt ausdrücklich, dass er die Hinweise zum Datenschutz zur Kenntnis genommen hat.
              </p>
            </template>
          </basic-checkbox>
          <p class="font-esso mt-3">
            * erforderliche Angaben
          </p>
          <button
            class="btn btn-lg btn-primary my-5"
            type="submit"
          >
            Jetzt anfragen
          </button>
        </form>
      </ValidationObserver>
    </div>

    <Footer />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import axios from 'axios'
import Header from '../components/Header'
import Footer from '../components/Footer'
const getFragebogenDefault = () => ({
  tankstelleName: '',
  ansprechpartner: '',
  telefone: '',
  mobilnummer: '',
  email: '',
  street: '',
  ort: '',
  risikoort: '',
  abweichendeAdresse: '',
  isPaechter: '',
  taetigkeitTankstelle: '',
  taetigkeitWaschtrasse: '',
  taetigkeitPortalwaschanlage: '',
  taetigkeitWerkstatt: '',
  taetigkeitServicehalle: '',
  hasDrittanbieter: '',
  drittanbieterName: '',
  kassenArbeitsplaetze: '',
  anzahlZapfsaeulen: '',
  shopflaeche: '',
  oeffnungszeitVon: '',
  oeffnungszeitBis: '',
  externesLager: '',
  inhaltsversicherung: '',
  gebaeudeversicherung: '',
  betriebshaftpflicht: '',
  glas: '',
  elektronik: '',
  cyberversicherung: '',
  riskofrage1: '',
  riskofrage2: '',
  riskofrage3: '',
  riskofrage4: '',
  riskofrage5: '',
  cyberfrage1: '',
  cyberfrage2: '',
  cyberfrage3: '',
  cyberfrage4: '',
  cyberfrage5: '',
  risikofrageExtra: '',
  umsatzKraftstoff: '',
  umsatzWaschanlage: '',
  umsatzShop: '',
  vorgaengerInhaltsversicherung: '',
  vorgaengerBetriebshaftpflicht: '',
  vorgaengerElektronik: '',
  vorgaengerGlas: '',
  vorgaengerCyberversicherung: '',
  versicherungsnummer1: '',
  versicherungsnummer2: '',
  versicherungsnummer3: '',
  versicherungsnummer4: '',
  versicherungsnummer5: '',
  grundsaetzeDatenverarbeitung: '',
  einwilligungDatenverarbeitung: ''
})

// eslint-disable-next-line import/no-webpack-loader-syntax
const pdfPath = require('file-loader!./ESSO_Vorauss_VSchutz_ED4_13_Juni.pdf')

export default {
  name: 'Fragebogen',
  components: {
    Header,
    Footer,
    ValidationObserver
  },
  data: () => ({
    pdfPath,
    submitPending: false,
    submitSuccess: false,
    fragebogen: getFragebogenDefault(),
    datapolicyAccepted: false
  }),
  computed: {
    activitesRequired () {
      if (this.fragebogen.taetigkeitTankstelle || this.fragebogen.taetigkeitWaschtrasse || this.fragebogen.taetigkeitPortalwaschanlage || this.fragebogen.taetigkeitWerkstatt || this.fragebogen.taetigkeitServicehalle) return false
      return true
    }
  },
  created () {
    this.datapolicyAccepted = window.localStorage.getItem('datapolicyAccepted') || false
  },
  methods: {
    setCookiePolicy () {
      this.datapolicyAccepted = true
      window.localStorage.setItem('datapolicyAccepted', this.datapolicyAccepted)
    },
    async submit () {
      try {
        const valid = await this.$refs.fragebogenForm.validate()
        if (!valid) {
          let errors = []
          for (let elementName in this.$refs.fragebogenForm.ctx.errors) {
            if (this.$refs.fragebogenForm.ctx.errors[elementName].length > 0) {
              errors.push(elementName)
            }
          }
          document.querySelector(`input[name='${errors[0]}']`).scrollIntoView({ block: 'center', behavior: 'smooth' })
          return
        }
        this.submitPending = true
        await axios.post('/api/fragebogen', this.fragebogen)
        this.fragebogen = getFragebogenDefault()
        this.submitSuccess = true
      } catch (error) {
        this.submitSuccess = false
        console.log(error)
      } finally {
        this.submitPending = false
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/assets/scss/_variables.scss";
  .cookie-alert {
    position: fixed;
    bottom: 0;
    z-index: 999;
    left: 0;
    right: 0;
    background-image: linear-gradient(45deg, #1f4e96 0%, #1f4d94 12.47%, #1b4585 32.03%, #1a4380 51.54%, #1a427e 58.96%, #183c73 66.57%, #17396e 73.71%, #10274b 100%);

    a {
      color: #fff;
      text-decoration:underline;

      &:hover {
        color: darken(#fff, 25)
      }
    }
  }

  body {
    background: $light-blue;
  }
  .main {
    @media (min-width: 390px) {
      margin-top: -10px;
    }

    @media (min-width: 768px) {
      margin-top: -70px;
    }

    padding-left: 45px;
    padding-right: 45px;
    background: #fff;
    position: relative;
    &:before{
      background: #fff;
      height: 100px;
      content: '';
      z-index: 1;
      position: absolute;
      left: 0px;
      right: 0px;
      top: -30px;
    }

    .form, .success{
      z-index: 2;
      position: relative;
    }
  }

  .subline {
    color:#666666;
    font-size: 16px;
  }

  .risikofragen {
    padding-left: 15px;

    ul{
      padding-left: 15px;
      list-style: none;
      li{
        &:before{
          content: "•";
          position: absolute;
          left: 20px;
          line-height: 0.5;
          font-size: 13px;
          font-family: 'Open Sans', sans-serif;
        }

        margin-bottom: 10px;

        &:last-child {
          margin-bottom: 0;
        }

      }
    }
  }

  .dokumentLink {
    color: $primary;
    text-decoration: underline;
  }

</style>
